import React, { useEffect } from "react";
import Modal from "react-modal";
import { Currency } from "../../../../js/common/CurrencyFormatter";
import { ProductDetailInfo } from "../ProductDetailPageTypeConfig";
import ProductGaleryModalContent from "./ProductGaleryModalContent";
import { getPackageForGalleryModal } from "./productGalleryModalService";

interface ProductGalleryModalProperties {
    readonly product: ProductDetailInfo;
    readonly cheapestPrice: number;
    readonly startImageIndex: number;
    readonly currency: Currency;

    readonly actionDiscountCode: string | null;
    readonly megaClearanceSaleDiscountCode: string | null;
    readonly newProductsDiscountCode: string;

    readonly onAfterClose: () => void;
    readonly onAddToBasket: (productId: number) => void;
}

export default function ProductGalleryModal({
    product,
    cheapestPrice,
    startImageIndex,
    actionDiscountCode,
    megaClearanceSaleDiscountCode,
    newProductsDiscountCode,
    onAfterClose,
    onAddToBasket,
    currency,
}: ProductGalleryModalProperties): React.JSX.Element {
    const [modalIsOpen, setModalIsOpen] = React.useState(true);
    const [currentProduct, setCurrentProduct] = React.useState<ProductDetailInfo>(product);
    const [currentCheapestPrice, setCurrentCheapestPrice] = React.useState<number>(cheapestPrice);
    const [currentProductUrl, setCurrentProductUrl] = React.useState<string | undefined>(undefined);

    const requestCloseModal = (): void => {
        closeModal();
    };

    const closeModal = (): void => {
        setModalIsOpen(false);
    };

    const changeProductForModal = async (packageUrl: string): Promise<void> => {
        const packageGalleryModalProduct = await getPackageForGalleryModal(packageUrl);
        setCurrentProduct(packageGalleryModalProduct.product);
        setCurrentCheapestPrice(packageGalleryModalProduct.cheapestPrice);
        window.history.pushState({}, "", packageUrl);
        setCurrentProductUrl(packageUrl);
    };

    useEffect(() => {
        if (!modalIsOpen && currentProductUrl !== undefined) {
            window.location.href = currentProductUrl;
        }
    }, [modalIsOpen, currentProductUrl]);

    useEffect(() => {
        const handleTouchStart = (event: TouchEvent): void => {
            event.preventDefault();
        };

        window.addEventListener("touchstart", handleTouchStart);

        return (): void => {
            window.removeEventListener("touchstart", handleTouchStart);
        };
    }, []);

    return (
        <Modal
            isOpen={modalIsOpen}
            onAfterClose={onAfterClose}
            onRequestClose={requestCloseModal}
            className="modal-dialog modal-transition"
            overlayClassName="react-modal-backdrop gallery-modal-change in gallery-last modal-transition galleryModal"
        >
            <div className="modal-content">
                <div className="modal-header empty modal-header-image">
                    <button type="button" className="close" onClick={requestCloseModal}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                <div className="modal-body">
                    <ProductGaleryModalContent
                        product={currentProduct}
                        cheapestPrice={currentCheapestPrice}
                        startImageIndex={startImageIndex}
                        actionDiscountCode={actionDiscountCode}
                        megaClearanceSaleDiscountCode={megaClearanceSaleDiscountCode}
                        newProductsDiscountCode={newProductsDiscountCode}
                        currency={currency}
                        onAddToBasket={(): void => {
                            onAddToBasket(currentProduct.productId);
                            closeModal();
                        }}
                        onProductChange={(packageUrl): void => void changeProductForModal(packageUrl)}
                    />
                </div>
            </div>
        </Modal>
    );
}
